
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"confirm.save.workbook.title":"Um diese Aktion durchzuführen, müssen Sie die Arbeitsmappe speichern.","confirm.save.workbook.submit":"Arbeitsmappe speichern"},"en":{"confirm.save.workbook.title":"To perform this action, you must save the workbook.","confirm.save.workbook.submit":"Save workbook"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();